import { useTranslation } from "react-i18next"

interface HelpModalProps {
  onClose: () => void
}

export default function HelpModal({ onClose }: HelpModalProps) {
  const { t } = useTranslation()

  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-end sm:items-center justify-center p-0 sm:p-4">
      <div className="bg-white dark:bg-slate-900 w-full max-w-lg h-[85vh] sm:h-auto sm:max-h-[80vh] rounded-t-2xl sm:rounded-2xl shadow-2xl overflow-y-auto flex flex-col">
        <div className="sticky top-0 bg-white dark:bg-slate-900 z-10 px-5 py-4 border-b border-gray-200 dark:border-slate-700 flex items-center justify-between">
          <h2 className="text-xl font-bold text-gray-900 dark:text-white">{t("help.title")}</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 text-2xl leading-none p-1"
          >
            &times;
          </button>
        </div>

        <div className="px-5 py-4 space-y-6">
          <section>
            <h3 className="font-semibold text-gray-900 dark:text-white mb-2 flex items-center gap-2">
              <span className="text-xl">🗺️</span>
              {t("help.map.title")}
            </h3>
            <p className="text-gray-600 dark:text-gray-400 text-sm leading-relaxed">{t("help.map.description")}</p>
          </section>

          <section>
            <h3 className="font-semibold text-gray-900 dark:text-white mb-2 flex items-center gap-2">
              <span className="text-xl">📍</span>
              {t("help.addSpot.title")}
            </h3>
            <p className="text-gray-600 dark:text-gray-400 text-sm leading-relaxed">{t("help.addSpot.description")}</p>
          </section>

          <section>
            <h3 className="font-semibold text-gray-900 dark:text-white mb-2 flex items-center gap-2">
              <span className="text-xl">📸</span>
              {t("help.photos.title")}
            </h3>
            <p className="text-gray-600 dark:text-gray-400 text-sm leading-relaxed">{t("help.photos.description")}</p>
          </section>

          <section>
            <h3 className="font-semibold text-gray-900 dark:text-white mb-2 flex items-center gap-2">
              <span className="text-xl">💬</span>
              {t("help.comments.title")}
            </h3>
            <p className="text-gray-600 dark:text-gray-400 text-sm leading-relaxed">{t("help.comments.description")}</p>
          </section>

          <section>
            <h3 className="font-semibold text-gray-900 dark:text-white mb-2 flex items-center gap-2">
              <span className="text-xl">⭐</span>
              {t("help.ratings.title")}
            </h3>
            <p className="text-gray-600 dark:text-gray-400 text-sm leading-relaxed">{t("help.ratings.description")}</p>
          </section>

          <section>
            <h3 className="font-semibold text-gray-900 dark:text-white mb-2 flex items-center gap-2">
              <span className="text-xl">❤️</span>
              {t("help.favorites.title")}
            </h3>
            <p className="text-gray-600 dark:text-gray-400 text-sm leading-relaxed">{t("help.favorites.description")}</p>
          </section>

          <section>
            <h3 className="font-semibold text-gray-900 dark:text-white mb-2 flex items-center gap-2">
              <span className="text-xl">👤</span>
              {t("help.profile.title")}
            </h3>
            <p className="text-gray-600 dark:text-gray-400 text-sm leading-relaxed">{t("help.profile.description")}</p>
          </section>
        </div>
      </div>
    </div>
  )
}
